import api from './api'
import { BASE } from './config'

import {
  userStatuses,
  userTypes,
  haUserRoles,
  saUserRoles,
} from '../constants/users'

class UserService {
  getStatusText(status) {
    return userStatuses.find(({ id }) => status === id)?.name
  }

  getHAUsersRoles() {
    return haUserRoles
  }

  getSAUsersRoles() {
    return saUserRoles
  }

  getUserTypeText(userType) {
    return userTypes.find(({ id }) => userType === id).name
  }

  getUsers(search) {
    let URL = `${BASE}/users/`
    if (search) URL += `?search=${search}/`
    return api.get(URL)
  }

  getStaffUsers() {
    return api.get(`${BASE}/users/staff_users/`)
  }

  getUsersFilterOptions() {
    return api.get(`${BASE}/users/filter_list/`).then((resp) => {
      return resp.data.map((user) => ({
        ...user,
        value: user.uuid,
        label: user.full_name,
      }))
    })
  }

  addUser(profile) {
    return api.post(`${BASE}/users/`, {
      ...profile,
    })
  }

  updateUser(profile) {
    return api.patch(`${BASE}/users/${profile.uuid}/`, {
      ...profile,
    })
  }

  deleteUser(uuid) {
    return api.delete(`${BASE}/users/${uuid}/`)
  }

  resendInvite(uuid) {
    return api.post(`${BASE}/users/${uuid}/resend-invite/`)
  }

  getCurrentUser() {
    return api.get(`${BASE}/users/current/`)
  }

  setCurrentUserDeviceId(registration_id) {
    return api.post(`${BASE}/users/current/devices/`, { registration_id })
  }

  getCurrentUserProfile() {
    return api.get(`${BASE}/users/current/profile/`)
  }

  updateCurrentUserProfile({ data }) {
    return api.patch(`${BASE}/users/current/profile/`, data)
  }

  // company profile
  getCurrentCompanyProfile() {
    return api.get(`${BASE}/health_agencies/current/`)
  }

  updateCurrentCompanyProfile(profile) {
    return api.patch(`${BASE}/health_agencies/current/`, profile)
  }
}

export default new UserService()
